export default {
  methods: {
    calculateWorkerPrice(tw) {
      const total = tw.total_price;
      const units = tw.total_units > 0 ? tw.total_units : 1;
      const result = total / units;
      return Math.round(result * 1000) / 1000;
    },
    calculateTotalWorkerPrice(tw) {
      const result = tw.total_units * tw.price;
      return Math.round(result * 100) / 100;
    },
    calculateTotalDeltaWithRate(totalDelta, rate) {
      const totalManager = totalDelta * rate / 100;
      return Math.round(totalManager * 100) / 100;
    },
    calculateWorkersPrice(taskWorkers) {
      return taskWorkers
        .map(obj => obj.total_price)
        .reduce((acc, current) => acc + current, 0)
    },
    calculateWorkersHours(taskWorkers) {
      return taskWorkers
        .map(obj => obj.total_units)
        .reduce((acc, current) => acc + current, 0)
    },
    // Подсчёт Итого с заказчика
    calculateTotalPrice(item) {
      let totalPrice = item.total_price;

      if (item.payment_first != null) {
        totalPrice = item.payment_first * item.total_hours;
      }

      return totalPrice;
    },
    // Считаем итоговую дельту
    calculateTotalDelta(item) {
      if ((item.total_price === null) || (item.total_worker_price_with_comiss === null)) {
        return item.total_delta;
      }

      let totalDelta = item.total_delta;

      const totalPrice = item.total_price;
      const totalWorkerPrice = item.total_worker_price_with_comiss;
      const totalHours = item.total_hours;
      const managementCost = item.management_cost;
      const profitTaxPercent = item.profit_tax;

      const ndsPercent = item.nds;
      const bankCommission = item.bank_commission;
      const ipCommission = item.ip_commission;

      switch (item.payment_type_int) {
        case 0: // физ лицо
          totalDelta = this.deltaForIndividual(
            totalPrice,
            totalWorkerPrice
          );
          break;
        case 1: // юр лицо
          totalDelta = this.deltaForLegalEntity(
            totalPrice,
            totalWorkerPrice,
            managementCost,
            profitTaxPercent,
            ndsPercent
          );
          break;
        case 2: // ИП
          totalDelta = this.deltaForIndividualEntrepreneur(
            totalPrice,
            totalWorkerPrice,
            managementCost,
            profitTaxPercent,
            bankCommission,
            ipCommission,
            ndsPercent
          );
          break;
        case 3: // Юр лицо самозанятые
          totalDelta = this.deltaForLegalEntity(
            totalPrice,
            totalWorkerPrice,
            managementCost,
            profitTaxPercent,
            ndsPercent
          );
          break;
        default: break;
      }

      // Скидка у заказчика за час
      if (item.customer) {
        if (item.customer.sale > 0) {
          totalDelta = totalDelta - (totalHours * item.customer.sale);
        }
      }

      // Округление
      const totalDeltaRound = Math.round(totalDelta * 100) / 100;

      // Вычитаем расходы
      return totalDeltaRound;
    },

    // физ лицо
    deltaForIndividual(totalPrice, totalWorkerPrice) {
      return totalPrice - totalWorkerPrice;
    },
    // юр лицо
    deltaForLegalEntity(totalPrice, totalWorkerPrice, managementCost, profitTaxPercent, ndsPercent) {

      // Трансфер не должен идти в дельту
      let totalDelta = totalPrice;

      // НДС % изменяется в объекте
      const nds = (totalDelta * ndsPercent) / (100 + ndsPercent);
      totalDelta = totalDelta - nds;

      // Налог на прибыль 2%, изменяется в объекте
      let profitTax = 0.0;
      if (profitTaxPercent > 0) {
        const percentProfit = profitTaxPercent / 100;
        profitTax = totalDelta * percentProfit;
      }

      // Управленческие расходы 5%, изменяется в объекте
      let managementTax = 0.0
      if (managementCost > 0) {
        const percent = managementCost / 100;
        managementTax = totalDelta * percent;
      }

      totalDelta = totalDelta - profitTax - managementTax - totalWorkerPrice;

      return totalDelta;
    },
    // ИП
    deltaForIndividualEntrepreneur(totalPrice, totalWorkerPrice, managementCost, profitTaxPercent, bankCommission, ipCommission, ndsPercent) {
      // Трансфер не должен идти в дельту
      let totalDelta = totalPrice;

      // НДС % изменяется в объекте
      const nds = (totalDelta * ndsPercent) / (100 + ndsPercent);
      totalDelta = totalDelta - nds;

      // Комиссия ИП 7%, изменяется в объекте
      let ipCommissionSum = 0.0;
      if (ipCommission > 0) {
        const percentIpCommission = ipCommission / 100;
        ipCommissionSum = totalDelta * percentIpCommission;
      }

      totalDelta = totalDelta - ipCommissionSum;

      // Банковская комиссия 1%, изменяется в объекте
      let bankCommissionSum = 0.0;
      if (bankCommission > 0) {
        const percentBankCommission = bankCommission / 100;
        bankCommissionSum = totalDelta * percentBankCommission;
      }

      // Налог на прибыль 0%, изменяется в объекте
      let profitTax = 0.0;
      if (profitTaxPercent > 0) {
        const percentProfit = profitTaxPercent / 100;
        profitTax = totalDelta * percentProfit;
      }

      // Управленческие расходы
      let managementTax = 0.0
      if (managementCost > 0) {
        const percent = managementCost / 100;
        managementTax = totalDelta * percent;
      }

      totalDelta = totalDelta - bankCommissionSum - profitTax - managementTax - totalWorkerPrice;

      return totalDelta;
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Tasks/taskService.js